export const personalize = (message, firstName, lastName, eventName) => {
  let personalizedString = message.replace(
    new RegExp("@EventName", "g"),
    eventName
  );
  personalizedString = personalizedString.replace(
    new RegExp("@FirstName", "g"),
    firstName
  );
  personalizedString = personalizedString.replace(
    new RegExp("@LastName", "g"),
    lastName
  );

  return personalizedString;
};



// WEBPACK FOOTER //
// ./utils/Personalize.js